<template>
<div class="section">
    <div class="container content-area">
        <h1 class="title is-5 is-uppercase">{{site_data.title}}</h1>
        <div class="columns">
            <article class="is-7 column">
                <dl>
                    <dt v-if="site_data.aliases">Collection Name(s)</dt>
                    <dd v-if="site_data.aliases">{{site_data.aliases}}</dd>
                    <dt v-if="site_data.creator">Contributor</dt>
                    <dd v-if="site_data.creator">{{site_data.creator}}</dd>
                    <dt v-if="site_data.first || site_data.last">Dates covered</dt>
                    <dd v-if="site_data.first || site_data.last">
                        {{site_data.first}}<template v-if="site_data.last"> - {{site_data.last}}</template>
                    </dd>
                    <dt v-if="site_data.content">Description</dt>
                    <dd v-if="site_data.content">
                        <div class="content" v-html="site_data.content"></div>
                    </dd>
                    <dt v-if="site_data.record_types && site_data.record_types.length">Record Types</dt>
                    <dd v-if="site_data.categories && site_data.categories.length"><strong>Categories</strong>: {{site_data.categories.join(' · ')}}</dd>
                    <dd v-if="site_data.record_types && site_data.record_types.length">{{site_data.record_types.join(', ')}}</dd>
                    <dt v-if="site_data.formats && site_data.formats.length">Formats</dt>
                    <dd v-if="site_data.formats && site_data.formats.length">{{site_data.formats.join(', ')}}</dd>
                    <dt v-if="site_data.artefacts">Artefacts</dt>
                    <dd v-if="site_data.artefacts">{{site_data.artefacts.join(', ')}}</dd>
                    <dt v-if="site_data.publications">Publications</dt>
                    <dd v-if="site_data.publications">{{site_data.publications.join(', ')}}</dd>
                    <dt v-if="site_data.quantity">Quantity</dt>
                    <dd v-if="site_data.quantity">
                        <ul>
                            <li v-if="site_data.quantity.linear"><strong>Linear Metre</strong>: {{site_data.quantity.linear}}</li>
                            <li v-if="site_data.quantity.photos"><strong>Photos</strong>: {{site_data.quantity.photos}}</li>
                            <li v-if="site_data.quantity.posters"><strong>Posters</strong>: {{site_data.quantity.posters}}</li>
                            <li v-if="site_data.quantity.plans"><strong>Plans</strong>: {{site_data.quantity.plans}}</li>
                        </ul>
                    </dd>
                    <dt v-if="site_data.ref">Reference Number</dt>
                    <dd v-if="site_data.ref">{{site_data.ref}}</dd>
                    <dt v-if="site_data.location">Location</dt>
                    <dd v-if="site_data.location">{{site_data.location}}</dd>
                    <dt v-if="site_data.access">Access</dt>
                    <dd v-if="site_data.access">{{site_data.access}}</dd>
                    <dt v-if="site_data.access_conditions">Access conditions</dt>
                    <dd v-if="site_data.access_conditions">{{site_data.access_conditions}}</dd>
                    <dt>Address</dt>
                    <dd v-if="site_data.address_online" v-html="site_data.address_online"></dd>
                    <dd v-else>Please use the <router-link to="/contact">Contact us page</router-link> for information about how to get in touch with the Contributor.</dd>
                    <!-- <dt v-if="site_data.record_online">Record Online</dt>
                    <dd v-if="site_data.record_online">{{site_data.record_online}}</dd> -->
                    <dt v-if="site_data.finding_aids">Catalogue/Index</dt>
                    <dd v-if="site_data.finding_aids">{{site_data.finding_aids}}</dd>
                    <dt v-if="site_data.attachment">Attachment</dt>
                    <dd v-if="site_data.attachment">{{site_data.attachment.url}}</dd>
                    <dt v-if="site_data.notes">Notes</dt>
                    <dd v-if="site_data.notes">{{site_data.notes}}</dd>
                </dl>
            </article>
            <aside class="column is-5">
                <div class="is-sticky">
                    <dl>
                        <dt v-if="site_data.keywords">Keywords</dt>
                        <dd v-if="site_data.keywords">{{site_data.keywords.join(' · ')}}</dd>
                        <dt v-if="site_data.productions">Productions</dt>
                        <dd v-if="site_data.productions">{{site_data.productions.join(' · ')}}</dd>
                        <dt v-if="site_data.last_update">Last Update</dt>
                        <dd v-if="site_data.last_update">{{site_data.last_update}}</dd>
                    </dl>
                    <hr />
                    <p><router-link class="button is-primary" :to="site_data.siteconfig.search_page">Go back</router-link></p>
                </div>
            </aside>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name        :   'TheatreArchivePage',
    props       :   ['site_data', 'is_mobile'],
    computed    :   {
        aliases()
        {
            if (!this.site_data) return null;
            if (this.site_data.aliases.length) {
                if (this.site_data.aliases[0] == this.site_data.title) {
                    this.site_data.aliases.shift();
                }
                return this.site_data.aliases;
            }
        }
    }
}

// 'CollectionName'        =>  'Text',
// 'Reference'             =>  'Text',
// 'FirstDate'             =>  'Varchar(64)',
// 'LastDate'              =>  'Varchar(64)',
// 'QuantityLm'            =>  'Varchar(128)',
// 'QuantityPhotos'        =>  'Varchar(128)',
// 'QuantityPosters'       =>  'Varchar(128)',
// 'QuantityPlans'         =>  'Varchar(128)',
// 'Notes'                 =>  'Text',
// 'LastUpdate'            =>  'Date',
// 'Access'                =>  'Varchar(128)',
// 'AccessConditions'      =>  'Text',
// 'AddressOnline'         =>  'Boolean',
// 'RecordOnline'          =>  'Boolean',
// 'OnlineAddressURL'      =>  'Varchar(1024)',
// 'FindingAids'           =>  'Varchar(1024)',
// 'NZTANotes'             =>  'HTMLText'
</script>



// WEBPACK FOOTER //
// src/components/pages/TheatreArchivePage.vue